// extracted by mini-css-extract-plugin
module.exports = {"confirmationHeader":"style_confirmationHeader__E5LD8","subtext":"style_subtext__2wJUy","successBtn":"style_successBtn__3WJA8"};